"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartSortingDialog = exports.ChartSortingWithIntl = exports.ChartSorting = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var ChartSortingDropdownBody_1 = require("./ChartSortingDropdownBody");
var ChartSortingDropdown_1 = require("./ChartSortingDropdown");
var Button_1 = require("../Button");
/**
 * @internal
 */
exports.ChartSorting = function (_a) {
    var currentSort = _a.currentSort, availableSorts = _a.availableSorts, intl = _a.intl, bucketItems = _a.bucketItems, buttonNode = _a.buttonNode, onCancel = _a.onCancel, onApply = _a.onApply, enableRenamingMeasureToMetric = _a.enableRenamingMeasureToMetric;
    var _b = tslib_1.__read(react_1.useState(currentSort), 2), currentSelectedSort = _b[0], setCurrentSort = _b[1];
    var handleApply = react_1.useCallback(function () {
        onApply(currentSelectedSort);
    }, [currentSelectedSort]);
    var onSelect = function (item) {
        setCurrentSort(item);
    };
    var isApplyEnabled = react_1.useMemo(function () { return !isEqual_1.default(currentSort, currentSelectedSort); }, [currentSort, currentSelectedSort]);
    return (react_1.default.createElement(ChartSortingDropdownBody_1.ChartSortingDropdownBody, { buttonNode: buttonNode, onClose: onCancel },
        react_1.default.createElement("div", { className: "gd-sort-charting-dropdown-header s-sort-charting-dropdown-header" },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "sorting.dropdown.header" })),
        react_1.default.createElement("div", { className: "gd-sort-charting-body gd-sort-charting-dropdown" },
            react_1.default.createElement(ChartSortingDropdown_1.ChartSortingDropdown, { currentSort: currentSelectedSort, availableSorts: availableSorts, bucketItems: bucketItems, intl: intl, onSelect: onSelect, enableRenamingMeasureToMetric: enableRenamingMeasureToMetric })),
        react_1.default.createElement("div", { className: "gd-chart-sorting-dropdown-footer" },
            react_1.default.createElement(Button_1.Button, { className: "gd-button-secondary gd-button-small s-sorting-dropdown-cancel", value: intl.formatMessage({ id: "cancel" }), onClick: onCancel }),
            react_1.default.createElement(Button_1.Button, { className: "gd-button-action gd-button-small s-sorting-dropdown-apply", value: intl.formatMessage({ id: "apply" }), onClick: handleApply, disabled: !isApplyEnabled }))));
};
/**
 * @internal
 */
exports.ChartSortingWithIntl = react_intl_1.injectIntl(exports.ChartSorting);
/**
 * @internal
 */
exports.ChartSortingDialog = function (props) { return (react_1.default.createElement(sdk_ui_1.IntlWrapper, { locale: props.locale },
    react_1.default.createElement(exports.ChartSortingWithIntl, tslib_1.__assign({}, props)))); };
//# sourceMappingURL=ChartSorting.js.map